import { FC, useEffect, useState } from 'react';
import { isNotEmpty, replaceEmpty } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { postMessageToParent } from 'src/common/utils/ways';
import { post } from '@/common/request';
import styles from './index.module.less';
import { Button, Typography } from 'antd';
import V2Table from '@/common/components/Data/V2Table';
import V2Tabs from '@/common/components/Data/V2Tabs';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

/**
 * @description 收藏列表右侧内容
 * @return {*}
 * @demo
 */
const RightContent: FC<{
  requirementId, // 需求id
  leftKey,
  folderNum,
  setRefresh
}> = ({ requirementId, leftKey, folderNum, setRefresh }) => {

  const tabs = [{ label: `场地点位 ${folderNum.siteLocationNum}`, key: '1' }];
  const [filters, setFilters] = useState<any>({});
  const [activeKey, setActiveKey] = useState('1');

  const [requesting, setRequesting] = useState(false);

  const defaultColumns: any = [
    {
      key: 'name',
      title: '场地/点位名称',
      width: 220,
      fixed: 'left',
      render(val, record) {
        const placeComp = isNotEmpty(record.placeName) ? <span>{record.placeName}</span> : null;
        const spotComp = isNotEmpty(record.spotName) ? <span>{record.spotName}</span> : null;
        const fullComp = <span className={record.tntSpotId ? 'pointer c-006' : 'c-222'} onClick={() => methods.spotDetail(record.tntSpotId)}>
          {placeComp}{!!placeComp && !!spotComp && <span>/</span>}{spotComp}
        </span>;
        return <Typography.Text style={{ width: 220 }} ellipsis={{ tooltip: { color: '#fff', title: fullComp } }}>
          {fullComp}
        </Typography.Text>;
      }
    },
    { key: 'locationType', title: '位置类型', width: 100, render: (val) => replaceEmpty(val) },
    { key: 'floor', title: '所在楼层', width: 100, render: (val) => replaceEmpty(val) },
    { key: 'area', title: '展位面积', width: 100, render: (val) => replaceEmpty(val) },
    { key: 'openTime', title: '经营时间', width: 160, render: (val) => replaceEmpty(val) },
    {
      title: '操作',
      key: 'operate',
      width: 100,
      fixed: 'right',
      render: (_, record) => <Button type='link' disabled={requesting} onClick={() => methods.cancelCollect(record.id)}>取消收藏</Button>,
      whiteTooltip: true,
      dragChecked: true
    }
  ];

  /* hooks */
  useEffect(() => {
    if (leftKey) {
      setFilters({ ...filters, requirementId, favourFolderId: leftKey });
    }
  }, [leftKey]);

  /* methods */
  const methods = useMethods({
    cancelCollect: (locationId) => {
      setRequesting(true);
      // https://yapi.lanhanba.com/project/546/interface/api/70188
      post('/clusterLocationFavor/build', { locationId, build: false, favourFolders: [leftKey] }).then(() => {
        V2Message.success('取消收藏成功');
        setFilters({ ...filters });
        setRefresh(true);
      }).finally(() => {
        setRequesting(false);
      });
    },
    // filter变化的时候执行请求接口的操作
    loadData: async (params) => {
      const url = '/clusterLocationFavor/locationPage';
      const data = await post(url, params);
      return {
        dataSource: data.objectList || [],
        count: data.totalNum || 0,
      };
    },

    // 场地详情（在 LCN 的内嵌 iframe 生效）
    placeDetail(id) {
      console.log('placeDetail', id);
      id && postMessageToParent({ type: 'placeDetail', data: id }, '*');
    },
    // 点位详情（在 LCN 的内嵌 iframe 生效）
    spotDetail(id) {
      console.log('spotDetail', id);
      id && postMessageToParent({ type: 'spotDetail', data: id }, '*');
    },

  });

  return (
    <div className={styles.right}>
      <V2Tabs className={styles.collectTabs} items={tabs} activeKey={activeKey} onChange={setActiveKey} />
      <V2Table
        className={styles.collectTable}
        rowKey='id'
        hideColumnPlaceholder
        filters={filters}
        defaultColumns={defaultColumns}
        onFetch={methods.loadData}
        scroll={{ x: 'max-content', y: window.innerHeight - 218 }} // calc(100vh - 218px) tabs:52 + title:60 + 分页:64 + table头部:42
      />
    </div>
  );
};

export default RightContent;
